var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.264 7.83923C13.2134 7.83923 11.8474 6.06908 10.2294 3.91962L7.29555 0H3.83162C1.92188 0 0.367188 0.012897 0.367188 0.0374262C0.367188 0.0632198 2.39021 2.78166 4.85578 6.06908C7.32134 9.36914 9.33173 12.1124 9.31858 12.164C9.29405 12.2014 7.27102 14.4141 4.82999 17.0566C2.37757 19.6987 0.367188 21.8998 0.367188 21.9372C0.367188 21.9746 0.809725 22.0004 1.35291 22.0004H2.327L6.18339 17.8153C8.30706 15.5146 10.103 13.5796 10.1789 13.5163C10.28 13.4397 11.3168 14.7175 13.5295 17.6888L16.7411 21.9878L20.1923 22.0004C22.0773 22.0004 23.632 21.963 23.632 21.8998C23.632 21.8482 21.4952 18.9659 18.8905 15.4888L14.1491 9.17949L14.7555 8.53465C15.0974 8.19275 16.8169 6.3346 18.5744 4.42537C20.3319 2.51589 21.9756 0.732842 22.2285 0.468331L22.6711 0H20.6101L16.9813 3.91962C14.9967 6.06908 13.3146 7.83923 13.264 7.83923ZM10.5457 11.1644C6.72677 6.05675 3.54126 1.7831 3.49093 1.69459C3.40192 1.54337 3.66795 1.51758 4.96977 1.51758H6.53711L13.5428 10.8741C17.3863 16.0207 20.5602 20.2938 20.5719 20.357C20.5977 20.4329 20.0158 20.4835 19.0546 20.4835L17.4999 20.4706L10.5457 11.1644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.efbad575a8b2fc72787f292a99fa9c11.svg";
export { ForwardRef as ReactComponent };